import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import Title from "@airasia/phoenix-components/components/Title"
// import _ from "lodash"

import { GTM_PROJECT_CATEGORY } from "../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../utils/functions"
import styled from "styled-components"

const Wrapper = styled.div`
  margin-top: 2%;
  margin-bottom: 2%;

  #carouselTitle {
    margin: 0px 8px;
    text-align: left;

    @media only screen and (max-width: 599px) {
      margin: 0px 16px;
    }
  }

  div[class^="CarouselSlider__SliderButtonContainer"] {
    z-index: 99;
  }
`

export default function carousel(props) {
  const { location, headline, subheadline, translations } = props

  const CardData = props.data.map((x, index) => {
    // change http paths to https
    // if (x.gallery.images[0].links["350px"].slice(0, 5) === "http:") {
    //   x.gallery.images[0].links["350px"] =
    //     "https:" + x.gallery.images[0].links["350px"].slice(5)
    // }

    return {
      accessibilityText: "carousel",
      attractText: x.tags.label_above.value,
      additionalText: x.tags.left_view.value,
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      cta: translations.cta,
      currencyCode: x.prices.total_inclusive_price.currency,
      discount: "",
      hidden: "",
      image: x.thumbnailImage["350px"],
      imageAlt: `${x.name} hotel at ${location}`,
      labelColor: "",
      location: x.headline,
      mobileAppImageURL: "",
      newTab: "TRUE",
      position: "",
      price: Math.floor(x.prices.total_inclusive_price.value),
      priceClarification: translations.priceClarification,
      priceDisclaimer: translations.priceDisclaimer,
      // primaryLabel: x.tags.left_view.value,
      productID: "",
      productType: "",
      rating: "",
      secondaryImage: "",
      secondaryLabel: x.tags.right_view.value,
      star: x.star_rating.rating,
      subtitle: "",
      timer: "",
      title: x.name,
      url: x.url,
    }
  })

  const gtmUserType = getGtmUserType()

  return CardData.length !== 0 ? (
    <Wrapper>
      {headline && (
        <Title
          type="h2"
          customProperties={{
            id: "carouselTitle",
          }}
        >
          {headline}
        </Title>
      )}
      <Carousel
        accessible
        cardConfig={{
          focusEffect: true,
        }}
        data={[...CardData]}
        heading={{
          cardCount: "5",
          gtmParameters: {
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: `${GTM_PROJECT_CATEGORY} | {{consumername}}`,
            eventLabelCardClick: `${GTM_PROJECT_CATEGORY} | ${gtmUserType} | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
            eventLabelHeadlineClick: `${gtmUserType}  | headline | {{headline}}`,
            eventLabelView: `${GTM_PROJECT_CATEGORY} | ${gtmUserType}`,
          },
          headline: "",
          headlineType: "h2",
          headlineStyle: "h2",
          layoutName: "lob_widget",
          showMoreURL: "",
          subHeadline: subheadline,
          widgetID: "",
          widgetName: "Hotel Location Widget",
          widgetWidth: "3",
        }}
        gtmConsumerName={props.gtmConsumerName}
        fireGtm={obj => {
          fireGtmEvent(obj)
        }}
        // isLoading={CardData.length === 0}
        handleClick={function noRefCheck() {}}
        templateType="productCard"
        theme="AIRASIA_CLASSIC"
        lazyLoadImage={true}
        enableProgressiveImageLoading={true}
      />
    </Wrapper>
  ) : (
    <></>
  )
}
